<template>
  <header
    class="h-16 shrink-0 flex items-center gap-3 px-4 sm:px-6 border-b border-untitled-gray-200 bg-white sticky top-0 z-20"
  >
    <button
      type="button"
      class="p-2 -ml-2 text-untitled-gray-600 hover:text-emerald-700"
      aria-label="Open menu"
      @click="handleToggleSidebar()"
    >
      <MenuIcon class="w-6 h-6" />
    </button>

    <div class="flex-1 max-w-md" />

    <div class="flex-1"></div>

    <el-button v-if="!isLearner" class="" @click="handleInviteUsers">
      <UserAddIcon class="w-4 h-4 sm:mr-1.5" />
      <span class="hidden sm:flex"> Invite Users </span>
    </el-button>

    <button
      v-if="!isLearner"
      type="button"
      class="bg-app-primary !border-app-primary hover:bg-app-secondary cursor-pointer text-app-white text-sm rounded py-1.5 shrink-0 px-4 flex justify-center items-center gap-1"
      @click="handleUploadContent"
    >
      <PlusIcon class="w-4 h-4 sm:mr-1.5" />
      <span class="hidden sm:flex"> Upload Content </span>
    </button>
    <V4GlobalSearch />

    <V4TopNotification />
    <V4TopAppsMenu />
    <V4UserMenu />
    <CreateUnitDialog
      :isCreateUnitDialogOpen="showUploadContentDialog"
      @closeCreateUnitDialog="showUploadContentDialog = false"
    />
    <V4InviteUserDialog
      :open="showInviteUsersDialog"
      @cancelEvent="showInviteUsersDialog = false"
      @sendEvent="handleSendEvent"
      :error="errorData"
      v-if="showInviteUsersDialog"
    />
    <NotificationDialog
      v-if="showNotificationDialog"
      @close="showNotificationDialog = false"
      :content="message"
    />
  </header>
</template>

<script setup>
import { ref, computed, defineProps } from "vue";
import { ElButton } from "element-plus";
import { MenuIcon, UserAddIcon, PlusIcon } from "@heroicons/vue/outline";
import { useLayoutStore } from "@/stores/useLayoutStore";
import { useAuthStore } from "@/stores";
import V4TopNotification from "@/components/layout/v4/V4TopNotification.vue";
import CreateUnitDialog from "@/components/unit/CreateUnitDialog.vue";
import V4GlobalSearch from "@/components/layout/v4/V4GlobalSearch.vue";
import V4InviteUserDialog from "@/components/v4/invite-user/V4InviteUserDialog.vue";
import V4TopAppsMenu from "@/components/layout/v4/V4TopAppsMenu.vue";
import V4UserMenu from "@/components/layout/v4/V4UserMenu.vue";
import NotificationDialog from "@/components/partials/NotificationDialog";

defineProps({
  collapsed: {
    type: Boolean,
    default: false,
  },
});

const layoutStore = useLayoutStore();
const authStore = useAuthStore();
const isLearner = computed(() => authStore.isLearner);
const showUploadContentDialog = ref(false);
const showInviteUsersDialog = ref(false);
const showNotificationDialog = ref(false);
const message = ref("");
const errorData = ref(null);

const handleInviteUsers = () => {
  showInviteUsersDialog.value = true;
};

const handleUploadContent = () => {
  showUploadContentDialog.value = true;
};

const handleToggleSidebar = () => {
  layoutStore.toggleSidebar();
  layoutStore.openMobileSidebar();
};

const handleSendEvent = () => {
  showNotificationDialog.value = true;
  message.value = "Invitation Sent";
  showInviteUsersDialog.value = false;
};
</script>

<style scoped>
.search-input :deep(.el-input__wrapper) {
  padding-left: 2.25rem;
}
</style>
